export default __webpack_public_path__ + "static/media/wallet.0f23b192.svg";